module.exports = __webpack_public_path__ + "media/images/recruit/common/logo-5520973a9c41e9ef509a14d0f11fb6d6.svg";